import { render, staticRenderFns } from "./DecisionPurposeFormModal.vue?vue&type=template&id=1dea6328&"
import script from "./DecisionPurposeFormModal.vue?vue&type=script&lang=js&"
export * from "./DecisionPurposeFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports